<script>
import { replace } from "svelte-spa-router";

import RecetasController from "../../controlador/recetasController.svelte";
let control;
let nombre = '',cuerpo = '';

async function guardar(){
    await control.crearPlantilla(nombre,cuerpo);
    replace('/home');
}
</script>
<RecetasController bind:this={control} />
<div class="container centro">
    <div class="fila">
      <input type="text" bind:value={nombre} placeholder="Nombre de la Plantilla">
    </div>
    <div class="cuerpo">
      <textarea bind:value={cuerpo} placeholder="Plantilla de Receta..." cols="30" rows="10"></textarea>
    </div>
    <div class="fila">
      <button on:click={guardar} class="boton"><i class="ph-floppy-disk"></i> Guardar</button>
      <a class="boton" href="#/home"><i class="ph-x-circle"></i> Volver</a>
    </div>
  </div>

<style>
    .centro{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }
    .fila{
      width: 90%;
      max-width: 380px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cuerpo{
      width: 90%;
      max-width: 380px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    input{
      width: 90%;
      max-width: 380px;
      margin-bottom: 10px;
      border: none;
      outline: none;
      border-radius: 10px;
      height: 30px;
      padding: 5px;
    }
    textarea{
      width: 90%;
      max-width: 380px;
      height: 300px;
      border-radius: 10px;
      border: none;
      outline: none;
      resize: none;
      padding: 5px;
    }
    .boton{
      margin: 10px;
      background: transparent;
      padding: 5px;
      color: white;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      outline: none;
      cursor: pointer;
    }
    i{
      margin-top: 5px;
      font-size: 30px;
    }
  </style>